import subscriber from "../utils/subscribe-actions";
import {requestValidateCoupon} from "../libs/apiv2-requests";
import {calcDiscount, discountText} from "../utils/payment";
import {Spinner} from "../libs/spinner";

export default context => {
    const container = $('.subscription-products-list', context)
    if (container.length) {
        const segData2Modifier = (price, segData) => {
            return segData.m === 'percentage'
                ? price * segData.v / 100
                : segData.v
        }

        container.on('calculate-total', function () {
            const sum = (partial, a) => partial + a
            const val = (e) => parseFloat((e.is('input') ? e.val() : e.text()) || 0)
            let total = $('.subscription-product-row', this).map(
                (i, e) => Math.max(0, val($('.product-price', e)) * ($('.product-count', e).val() || 0) + val($('.segment-price', e)))
            )
                .get()
                .reduce(sum, 0)
            let showSubTotal = false
            const couponInfo = $('input.coupon-code', container).data('validation')
            $('.price-subtotal', this).text(total)
            if (couponInfo && couponInfo.isValid) {
                showSubTotal = true
                total = calcDiscount(total, couponInfo.discountMethod, couponInfo.discountValue)
            }

            const feeElement = $('[data-service-fee]', this)
            if (feeElement.length) {
                showSubTotal = true
                const fee = Math.floor(total * feeElement.data('service-fee')) / 100
                $('.price-service-fee', this).text(fee)
                total = total + fee
            }

            showSubTotal ? $('.subtotal', this).show() : $('.subtotal', this).hide()
            $(".price-total", this).text(total);
        })

        $('.product-count', container).on('change', function () {
            const row = $(this).closest('.subscription-product-row')
            if (!!parseFloat($(this).val())) {
                if (!$(this).data('checked')) {
                    // Applying discount if the first time selecting the product.
                    const price = row.find('.product .product-price').text()
                    const select = row.closest('.subscription-product-row').find('.segment-select')
                    if (!select.val()) {
                        const max = select.find('option[data-discount]:not(:disabled)')
                            .map((i, e) => {
                                return {id: $(e).val(), price: segData2Modifier(price, $(e).data('discount'))}
                            })
                            .get()
                            .reduce((p, a) => a.price > p.price ? a : p, {id: '', price: 0})
                        if (max && max.id) {
                            select.val(max.id).trigger('change')
                        } else {
                            select.val(select.find('option[data-discount]:not(:disabled)').first().val()).trigger('change')
                        }
                    }
                    $(this).data('checked', true)
                }
                const type = row.data('type')
                if (type !== 'ticket') {
                    row.siblings(`.subscription-product-row[data-type=${type}]`).find('input.product-count').attr('disabled', true)
                }
            } else {
                const type = row.data('type')
                if (type !== 'ticket') {
                    row.siblings(`.subscription-product-row[data-type=${type}]`).find('input.product-count').attr('disabled', false)
                }
            }

            container.trigger('calculate-total')
        })
        $('.product-price', container).on('change', function () {
            container.trigger('calculate-total')
        })

        $('.segment-select', container).on('change', function () {
            const productContainer = $(this).closest('.subscription-product-row')
            productContainer.children('.segment').remove()
            const segData = $(this).find(':checked').data('discount')
            if (segData) {
                productContainer.find('.product').after(function () {
                    const label = '' + segData.v + (segData.m === 'percentage' ? '%' : getComputedStyle(document.documentElement).getPropertyValue('--coing-currency-sign').replaceAll('"', ''))
                    const price = segData2Modifier(productContainer.find('.product .product-price').text(), segData)
                    return `<div class="grid-row segment"><div class="grid-col left"><span>${label} OFF</span><span class="price-value segment-price">-${price}</span></div><div class="grid-col right"></div></div>`
                })
            }
            container.trigger('calculate-total')

            //
            const ids = $('select.segment-select option:checked', container).map((i, e) => $(e).data('segid')).get().filter(e => !!e)
            $('select.segment-select option', container)
                .attr('disabled', false)
                .filter(':not(:checked)')
                .filter(ids.map(i => `[data-segid=${i}]`).join(','))
                .attr('disabled', true)
        })

        $('.test-citizen-id', container).on('click', async function () {
            const subContainer = $(this).closest('.citizen-validation')
            subContainer.find('.help-block-error').remove()
            try {
                const response = await $.ajax({
                    url: '/site/auth/validate-id',
                    data: {
                        cid: cid,
                        id: subContainer.find('.input-citizen-id').val(),
                        data: 1,
                    }
                })
                if (response) {
                    openAlert(translate.subcriberForm.discountAvailable, 'success')
                    await subscriber.refreshForm()
                    $(`.subscription-products-list select.segment-select option[data-segid="${response.segmentAttached[0].segmentId}"]`, context).each(function () {
                        $(this).closest('select').val($(this).val()).trigger('change')
                    })
                }
                c
            } catch (e) {
                $('<p class="help-block-error help-block">')
                    .text(e.responseText || translate.site_error_general)
                    .appendTo(subContainer)
            }
        })

        $('input.coupon-code', container).on('blur', function () {
            if ($(this).val() !== '') {
                const spinner = new Spinner('.coupon-code.grid-row .right')
                spinner.show()
                const successCheck = result => {
                        result = result.data
                        $(this).data('validation', result)
                        if (result.isValid) {
                            $(this).siblings('.help-block').text('')
                            $('.coupon-discount-text', container).text(discountText(result.discountMethod, result.discountValue, true))
                        } else {
                            $(this).siblings('.help-block').text('Code is not valid')
                            $('.coupon-discount-text', container).text('')
                        }
                        container.trigger('calculate-total')
                    }
                requestValidateCoupon($(this).val())
                    .statusCode({
                        200: successCheck,
                        201: successCheck,
                        429: result => {
                            $(this).siblings('.help-block').text(window.translate.subcriberForm.too_many_coupon_attempts)
                            $('.coupon-discount-text', container).text('')
                            container.trigger('calculate-total')
                        }
                    })
                    .always(() => {
                        spinner.remove();
                    })
            } else {
                $(this).siblings('.help-block').text('')
                $('.coupon-discount-text', container).text('')
                container.trigger('calculate-total')
            }
        })

        container.trigger('calculate-total')
    }
}
